var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rp-users-content"},[_c('rp-users-header'),_c('rp-users-control')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }